// removed by extract-text-webpack-plugin
module.exports = {"drawerWrap":"qempo_drawer_drawerWrap-3khBwsu","open":"qempo_drawer_open-3lQU8iN","veil":"qempo_drawer_veil-LzHq6UP","right":"qempo_drawer_right--DxJAoz","bottom":"qempo_drawer_bottom-1nCsV08"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/drawer.scss
// module id = 1256
// module chunks = 0